import { SEOHead } from "@/components/SEOHead";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { ArrowRight, ShieldCheck, FileText, Shield, Briefcase, TrendingUp, Megaphone, Users, Settings, Globe, Lock, CreditCard, CheckCircle2 } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Link } from "react-router-dom";
import { useState } from "react";


const getConsultingData = (t: any) => [
  {
    id: "registration",
    title: t('consulting.items.registration.title'),
    heading: t('consulting.items.registration.heading'),
    subheading: t('consulting.items.registration.sub'),
    desc: t('consulting.items.registration.desc'),
    btn1: t('consulting.items.registration.title') === "Registration" ? "Learn More" : "Узнать больше",
    btn2: t('consulting.items.registration.title') === "Registration" ? "Contact Us" : "Связаться с нами",
  },
  {
    id: "licensing",
    title: t('consulting.items.licensing.title'),
    heading: t('consulting.items.licensing.heading'),
    subheading: t('consulting.items.licensing.sub'),
    desc: t('consulting.items.licensing.desc'),
    btn1: t('consulting.items.registration.title') === "Registration" ? "Learn More" : "Узнать больше",
    btn2: t('consulting.items.registration.title') === "Registration" ? "Contact Us" : "Связаться с нами",
  },
  {
    id: "strategy",
    title: t('consulting.items.strategy.title'),
    heading: t('consulting.items.strategy.heading'),
    subheading: t('consulting.items.strategy.sub'),
    desc: t('consulting.items.strategy.desc'),
    btn1: t('consulting.items.registration.title') === "Registration" ? "Learn More" : "Узнать больше",
    btn2: t('consulting.items.registration.title') === "Registration" ? "Contact Us" : "Связаться с нами",
  },

  {
    id: "crm",
    title: t('consulting.items.crm.title'),
    heading: t('consulting.items.crm.heading'),
    subheading: t('consulting.items.crm.sub'),
    desc: t('consulting.items.crm.desc'),
    btn1: t('consulting.items.registration.title') === "Registration" ? "Learn More" : "Узнать больше",
    btn2: t('consulting.items.registration.title') === "Registration" ? "Contact Us" : "Связаться с нами",
  },
  {
    id: "workflow",
    title: t('consulting.items.workflow.title'),
    heading: t('consulting.items.workflow.heading'),
    subheading: t('consulting.items.workflow.sub'),
    desc: t('consulting.items.workflow.desc'),
    btn1: t('consulting.items.registration.title') === "Registration" ? "Learn More" : "Узнать больше",
    btn2: t('consulting.items.registration.title') === "Registration" ? "Contact Us" : "Связаться с нами",
  },
  {
    id: "export",
    title: t('consulting.items.export.title'),
    heading: t('consulting.items.export.heading'),
    subheading: t('consulting.items.export.sub'),
    desc: t('consulting.items.export.desc'),
    btn1: t('consulting.items.registration.title') === "Registration" ? "Learn More" : "Узнать больше",
    btn2: t('consulting.items.registration.title') === "Registration" ? "Contact Us" : "Связаться с нами",
  },
  {
    id: "security",
    title: t('consulting.items.security.title'),
    heading: t('consulting.items.security.heading'),
    subheading: t('consulting.items.security.sub'),
    desc: t('consulting.items.security.desc'),
    btn1: t('consulting.items.registration.title') === "Registration" ? "Learn More" : "Узнать больше",
    btn2: t('consulting.items.registration.title') === "Registration" ? "Contact Us" : "Связаться с нами",
  },
  {
    id: "credit",
    title: t('consulting.items.credit.title'),
    heading: t('consulting.items.credit.heading'),
    subheading: t('consulting.items.credit.sub'),
    desc: t('consulting.items.credit.desc'),
    btn1: t('consulting.items.registration.title') === "Registration" ? "Learn More" : "Узнать больше",
    btn2: t('consulting.items.registration.title') === "Registration" ? "Contact Us" : "Связаться с нами",
  },
];


const consultingIcons = [FileText, ShieldCheck, TrendingUp, Users, Settings, Globe, Lock, CreditCard];

const consultingSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Consulting Services",
  "provider": {
    "@type": "LocalBusiness",
    "name": "AITIM Group"
  },
  "areaServed": "US",
  "description": "Expert consulting services for trucking businesses including company registration, licensing, strategy, CRM implementation, workflow optimization, and security."
};

const Consulting = () => {
  const { t } = useLanguage();
  const consultingData = getConsultingData(t);
  const [activeTab, setActiveTab] = useState(0);
  const [displayTab, setDisplayTab] = useState(0);
  const [animating, setAnimating] = useState(false);

  const handleTabChange = (i: number) => {
    if (i === activeTab || animating) return;
    setAnimating(true);
    setActiveTab(i);
    setTimeout(() => {
      setDisplayTab(i);
      setAnimating(false);
    }, 280);
  };

  const active = consultingData[displayTab];
  const ActiveIcon = consultingIcons[displayTab % consultingIcons.length];

  return (
    <div className="min-h-screen bg-background font-sans">
      <SEOHead 
        title={t('consulting.title1') + ' ' + t('consulting.title2')}
        description={t('consulting.desc')}
        canonical="/consulting"
        schemaJson={consultingSchema}
      />
      <Navbar />
      
      <main>
        {/* Hero Section */}
        <section className="relative pt-28 pb-16 lg:pt-48 lg:pb-32 overflow-hidden bg-navy-950">
          <div className="absolute inset-0 z-0">
            <video
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-cover object-center hidden md:block"
            >
              <source src="https://assets.cdn.filesafe.space/gUCbLLrJwD5vtwXYoPEZ/media/69f127e8c428703a042e614e.webm" type="video/webm" />
            </video>
            <img
              src="https://assets.cdn.filesafe.space/gUCbLLrJwD5vtwXYoPEZ/media/69f0ff9b40534248c5a223af.webp"
              srcSet="https://assets.cdn.filesafe.space/gUCbLLrJwD5vtwXYoPEZ/media/69f0ff9b40534248c5a223af.webp?w=480 480w, https://assets.cdn.filesafe.space/gUCbLLrJwD5vtwXYoPEZ/media/69f0ff9b40534248c5a223af.webp?w=768 768w, https://assets.cdn.filesafe.space/gUCbLLrJwD5vtwXYoPEZ/media/69f0ff9b40534248c5a223af.webp?w=1200 1200w"
              sizes="(max-width: 768px) 100vw, 1200px"
              alt="Consulting Services"
              fetchPriority="high"
              className="w-full h-full object-cover object-center md:hidden"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-navy-950/95 via-navy-950/80 to-navy-950/50"></div>
          </div>

          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-3xl">
              <div className="inline-block px-4 py-1.5 rounded-full bg-primary/20 text-primary font-semibold text-sm mb-6 border border-primary/30 tracking-wide uppercase">
                {t('consulting.badge')}
              </div>
              <h1 className="text-3xl md:text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight tracking-tight">
                {t('consulting.title1')}<br/><span className="text-primary">{t('consulting.title2')}</span>
              </h1>
              <p className="text-lg lg:text-xl text-white/80 mb-10 max-w-2xl leading-relaxed">
                {t('consulting.desc')}
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/free-consultation">
                  <Button size="lg" className="bg-primary hover:bg-primary/90 text-white rounded-sm px-8 h-14 text-lg w-full sm:w-auto">
                    {t('consulting.btn1')} <ArrowRight className="ml-2 w-5 h-5" />
                  </Button>
                </Link>
                <Link to="/free-consultation" className="w-full sm:w-auto">
                  <Button size="lg" variant="outline" className="border-white/20 bg-white/5 text-white hover:bg-white/10 hover:text-white rounded-sm px-8 h-14 text-lg w-full">
                    {t('consulting.btn2')} <ArrowRight className="ml-2 w-5 h-5" />
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Services Interactive Section */}
        <section className="py-24 bg-slate-50 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent"></div>
          <div className="container mx-auto px-4 relative z-10">
            <div className="text-center mb-16">
              <div className="text-primary font-bold tracking-widest uppercase text-xs mb-4">{t('consulting.expertise')}</div>
              <h2 className="text-3xl md:text-5xl font-extrabold text-navy-950">
                {t('consulting.compTitle1')} <span className="text-primary">{t('consulting.compTitle2')}</span>
              </h2>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-[280px_1fr] gap-6 max-w-6xl mx-auto">
              {/* Left: vertical nav pills */}
              <div className="flex flex-row lg:flex-col gap-2 overflow-x-auto lg:overflow-visible pb-2 lg:pb-0 scrollbar-none">
                {consultingData.map((service, i) => {
                  const NavIcon = consultingIcons[i % consultingIcons.length];
                  const isActive = activeTab === i;
                  return (
                    <button
                      key={service.id}
                      onClick={() => handleTabChange(i)}
                      className={`group flex items-center gap-3 px-5 py-4 rounded-2xl text-left transition-all duration-300 shrink-0 lg:shrink border ${
                        isActive
                          ? "bg-primary text-primary-foreground border-primary shadow-lg shadow-primary/20 scale-[1.02]"
                          : "bg-white text-slate-600 border-slate-200 hover:border-primary/30 hover:bg-primary/5 hover:text-navy-950"
                      }`}
                    >
                      <div className={`w-9 h-9 rounded-xl flex items-center justify-center shrink-0 transition-all duration-300 ${
                        isActive ? "bg-white/20" : "bg-slate-100 group-hover:bg-primary/10"
                      }`}>
                        <NavIcon className={`w-5 h-5 transition-colors duration-300 ${isActive ? "text-primary-foreground" : "text-primary"}`} strokeWidth={1.8} />
                      </div>
                      <span className="font-semibold text-sm whitespace-nowrap lg:whitespace-normal leading-tight">{service.title}</span>
                      {isActive && <ArrowRight className="ml-auto w-4 h-4 opacity-70 hidden lg:block" />}
                    </button>
                  );
                })}
              </div>

              {/* Right: animated content panel */}
              <div
                className="bg-white rounded-3xl border border-slate-100 shadow-xl overflow-hidden"
                style={{
                  opacity: animating ? 0 : 1,
                  transform: animating ? "translateY(16px) scale(0.98)" : "translateY(0) scale(1)",
                  transition: "opacity 0.28s cubic-bezier(0.4,0,0.2,1), transform 0.28s cubic-bezier(0.4,0,0.2,1)",
                }}
              >
                <div className="grid grid-cols-1 md:grid-cols-2 h-full">
                  {/* Content */}
                  <div className="p-8 md:p-12 flex flex-col justify-between">
                    <div>
                      <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center mb-8">
                        <ActiveIcon className="w-7 h-7 text-primary" strokeWidth={1.8} />
                      </div>
                      <div className="text-primary font-bold tracking-widest uppercase text-xs mb-3">{active.title}</div>
                      <h3 className="text-3xl md:text-4xl font-black text-navy-950 leading-tight mb-4">{active.subheading}</h3>
                      <p className="text-slate-500 leading-relaxed text-base mb-8">{active.desc}</p>
                    </div>
                    <div className="flex flex-wrap gap-3">
                      <Link to="/free-consultation" aria-label={`${active.btn1} ${active.title}`}>
                        <Button className="bg-primary hover:bg-primary/90 text-primary-foreground rounded-xl px-6 h-12 font-semibold">
                          {active.btn1} <span className="sr-only"> {active.title}</span> <ArrowRight className="ml-2 w-4 h-4" />
                        </Button>
                      </Link>
                      <Link to="/free-consultation">
                        <Button variant="outline" className="border-slate-200 text-navy-950 hover:bg-slate-50 hover:text-primary rounded-xl px-6 h-12 font-semibold bg-white">
                          {active.btn2}
                        </Button>
                      </Link>
                    </div>
                  </div>

                  {/* Visual panel */}
                  <div className="bg-gradient-to-br from-primary/5 via-primary/10 to-primary/5 flex items-center justify-center p-10 relative overflow-hidden min-h-[260px]">
                    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                      <div className="w-64 h-64 rounded-full border border-primary/10 absolute animate-ping" style={{ animationDuration: "4s" }} />
                      <div className="w-48 h-48 rounded-full border border-primary/15 absolute" />
                      <div className="w-32 h-32 rounded-full border border-primary/20 absolute" />
                    </div>
                    <div className="relative z-10 w-28 h-28 rounded-3xl bg-white shadow-2xl shadow-primary/20 flex items-center justify-center border border-primary/10">
                      <ActiveIcon className="w-14 h-14 text-primary" strokeWidth={1.2} />
                    </div>
                    <div className="absolute top-4 right-6 text-[80px] font-black text-primary/5 leading-none select-none pointer-events-none">
                      {String(displayTab + 1).padStart(2, "0")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>


        {/* Happy Customers Section */}
        <section className="py-24 bg-navy-950 text-white relative overflow-hidden">
          <div className="absolute inset-0 bg-[url('https://assets.cdn.filesafe.space/gUCbLLrJwD5vtwXYoPEZ/media/69f0ff9b40534248c5a223af.webp')] opacity-10 bg-cover bg-center"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-navy-950 via-navy-950/90 to-navy-950"></div>
          <div className="container mx-auto px-4 text-center relative z-10">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-16">{t('consulting.customers').split('happy customers!')[0]} <span className="text-primary">happy customers!</span></h2>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
              {[
                { icon: ShieldCheck, title: "Expertise", desc: "Years of industry experience ensure your cargo is in trusted, capable hands" },
                { icon: CheckCircle2, title: "Flexible Terms", desc: "Customer-friendly options tailored to meet your specific needs and budget" },
                { icon: Shield, title: "Quality Assurance", desc: "Top-notch service with a focus on safety, reliability, and timely delivery" }
              ].map((item, i) => (
                <div key={i} className="bg-white/5 border border-white/10 p-10 rounded-3xl backdrop-blur-sm hover:-translate-y-2 hover:bg-white/10 transition-all duration-300 group shadow-2xl">
                  <div className="w-16 h-16 rounded-2xl bg-primary/20 text-primary flex items-center justify-center mb-8 mx-auto group-hover:scale-110 group-hover:rotate-6 transition-transform duration-300">
                    <item.icon className="w-8 h-8" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-4">{item.title}</h3>
                  <p className="text-white/70 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Banners Section */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-5xl mx-auto">
              <Link to="/fuel-cards" className="block">
                <div className="relative rounded-[2rem] md:rounded-[2.5rem] overflow-hidden group cursor-pointer shadow-2xl hover:shadow-primary/30 transition-all duration-500 h-48 md:h-56 bg-black">
                  {/* New cinematic background image */}
                  <img
                    src="https://vibe.filesafe.space/1777392978847194987/assets/eb8ee3aa-631a-4271-9ab5-0652cd7aa6c3.png"
                    alt="Fuel Cards"
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 opacity-80"
                  />
                  {/* Dark gradient overlay for readability */}
                  <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/40 to-transparent"></div>
                  
                  {/* Content */}
                  <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
                    <h3 className="text-4xl md:text-6xl font-black text-white mb-6 tracking-tight drop-shadow-2xl">
                      FUEL CARDS
                    </h3>
                    <Button className="bg-white text-navy-950 hover:bg-primary hover:text-white rounded-full px-10 h-12 text-base font-bold shadow-lg transform hover:-translate-y-1 transition-all duration-300" aria-label={`${t('services.learnMore')} Fuel Cards`}>
                      {t('services.learnMore')} <span className="sr-only"> Fuel Cards</span>
                    </Button>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </section>

        {/* Stats & Hand Image Section */}
        <section className="py-24 bg-white overflow-hidden border-t border-slate-100">
          <div className="container mx-auto px-4">
            <div className="flex flex-col lg:flex-row items-center gap-16 max-w-7xl mx-auto">
              <div className="lg:w-1/2 relative group">
                <div className="absolute inset-0 bg-primary/20 blur-3xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>
                <img 
                  src="https://static.wixstatic.com/media/5c8a3f_692872a1103a43c3b151fb190660505e~mv2.png/v1/fill/w_960,h_706,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/5c8a3f_692872a1103a43c3b151fb190660505e~mv2.png" 
                  alt="AITIM Capital Card" 
                  loading="lazy"
                  className="w-full max-w-lg mx-auto drop-shadow-[0_20px_50px_rgba(0,0,0,0.15)] group-hover:-translate-y-4 group-hover:scale-105 transition-all duration-700 relative z-10"
                />
              </div>
              <div className="lg:w-1/2">
                <div className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary font-bold text-xs mb-6 tracking-widest uppercase">
                  {t('consulting.whyBadge')}
                </div>
                <h2 className="text-5xl md:text-7xl font-black text-navy-950 mb-16 tracking-tight">AITIM GROUP</h2>
                
                <div className="grid grid-cols-2 gap-x-8 gap-y-12">
                  <div className="group">
                    <div className="text-4xl md:text-6xl font-light text-primary mb-4 group-hover:scale-110 origin-left transition-transform duration-300">10+</div>
                    <div className="h-0.5 bg-slate-200 w-full mb-4 relative overflow-hidden">
                      <div className="absolute top-0 left-0 h-full bg-primary w-0 group-hover:w-full transition-all duration-500"></div>
                    </div>
                    <div className="text-sm font-bold tracking-widest text-slate-500 uppercase group-hover:text-navy-950 transition-colors">
                      {t('consulting.exp').includes('EXPERIENCE') ? t('consulting.exp').split('EXPERIENCE')[0] : t('consulting.exp').split('ОПЫТА')[0]}
                      {t('consulting.exp').includes('EXPERIENCE') ? 'EXPERIENCE' : 'ОПЫТА'}
                    </div>
                  </div>
                  <div className="group">
                    <div className="text-4xl md:text-6xl font-light text-primary mb-4 group-hover:scale-110 origin-left transition-transform duration-300">7000+</div>
                    <div className="h-0.5 bg-slate-200 w-full mb-4 relative overflow-hidden">
                      <div className="absolute top-0 left-0 h-full bg-primary w-0 group-hover:w-full transition-all duration-500"></div>
                    </div>
                    <div className="text-sm font-bold tracking-widest text-slate-500 uppercase group-hover:text-navy-950 transition-colors">
                      {t('consulting.trucks').includes('NETWORK') ? t('consulting.trucks').split('NETWORK')[0] : t('consulting.trucks').split('СЕТИ')[0]}
                      {t('consulting.trucks').includes('NETWORK') ? 'NETWORK' : 'СЕТИ'}
                    </div>
                  </div>
                  <div className="group">
                    <div className="text-4xl md:text-6xl font-light text-primary mb-4 group-hover:scale-110 origin-left transition-transform duration-300">100%</div>
                    <div className="h-0.5 bg-slate-200 w-full mb-4 relative overflow-hidden">
                      <div className="absolute top-0 left-0 h-full bg-primary w-0 group-hover:w-full transition-all duration-500"></div>
                    </div>
                    <div className="text-sm font-bold tracking-widest text-slate-500 uppercase group-hover:text-navy-950 transition-colors">
                      {t('consulting.sat').includes('SATISFACTION') ? t('consulting.sat').split('SATISFACTION')[0] : t('consulting.sat').split('КЛИЕНТОВ')[0]}
                      {t('consulting.sat').includes('SATISFACTION') ? 'SATISFACTION' : 'КЛИЕНТОВ'}
                    </div>
                  </div>
                  <div className="group">
                    <div className="text-4xl md:text-6xl font-light text-primary mb-4 group-hover:scale-110 origin-left transition-transform duration-300">20+</div>
                    <div className="h-0.5 bg-slate-200 w-full mb-4 relative overflow-hidden">
                      <div className="absolute top-0 left-0 h-full bg-primary w-0 group-hover:w-full transition-all duration-500"></div>
                    </div>
                    <div className="text-sm font-bold tracking-widest text-slate-500 uppercase group-hover:text-navy-950 transition-colors">
                      {t('consulting.awards').includes('RECOGNITIONS') ? t('consulting.awards').split('RECOGNITIONS')[0] : t('consulting.awards').split('ПРИЗНАНИЕ')[0]}
                      {t('consulting.awards').includes('RECOGNITIONS') ? 'RECOGNITIONS' : 'ПРИЗНАНИЕ'}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact CTA Section */}
        <section className="py-24 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="relative rounded-[2rem] md:rounded-[4rem] overflow-hidden group shadow-2xl">
                <div className="absolute inset-0">
                  <img 
                    src="https://static.wixstatic.com/media/11062b_d2d01247fc75405591814403f1351673~mv2.jpg/v1/fill/w_945,h_411,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/11062b_d2d01247fc75405591814403f1351673~mv2.jpg" 
                    alt="Truck Driving by Lake" 
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-white/20 group-hover:bg-white/10 transition-colors duration-500"></div>
                </div>
                <div className="relative z-10 py-20 md:py-32 flex flex-col items-center justify-center text-center px-4">
                  <h2 className="text-4xl md:text-6xl font-black text-navy-950 mb-10 tracking-tight drop-shadow-sm">
                    {t('consulting.ctaTitle')}
                  </h2>
                  <Link to="/free-consultation" aria-label={`${t('consulting.ctaBtn')} - ${t('consulting.ctaTitle')}`}>
                    <Button size="lg" className="bg-navy-950 text-white hover:bg-navy-900 rounded-full px-12 h-16 text-xl font-bold shadow-2xl transform hover:-translate-y-1 transition-all duration-300">
                      {t('consulting.ctaBtn')}
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Consulting;
